import { c as _c } from "react/compiler-runtime";
import { Tooltip } from 'platform/components';
import type { ReactNode } from 'react';
import type { CellRendererProps } from '../../types/CellRendererProps';
import type { TooltipGetter } from '../../types/TooltipGetter';
import { getCellClassName } from '../../utils/getCellClassName';
import { getTooltipProps } from '../../utils/getTooltipProps';
type MetaTextValue = {
  primary: string;
  secondary: string;
} | null;
type MetaTextCellRendererProps = CellRendererProps<MetaTextValue> & {
  getTooltipProps?: TooltipGetter;
};
const META_REGEX = /@\[([^\]]+)\]\(([^)]+)\)/g;
const parseMetaText = (cellValue: string): ReactNode[] => {
  const segments: (string | ReactNode)[] = [];
  let lastIndex = 0;
  const matches = Array.from(cellValue.matchAll(META_REGEX));
  matches.forEach((match, index) => {
    const matchStart = match.index!;
    const matchEnd = matchStart + match[0].length;
    if (matchStart > lastIndex) {
      segments.push(cellValue.substring(lastIndex, matchStart));
    }
    const name = match[1];
    const id = match[2];
    segments.push(<span key={`meta-${index}-${id}`} className="bg-[color:var(--color-blue-30,#e3f0ff)] inline">
        {name}
      </span>);
    lastIndex = matchEnd;
  });
  if (lastIndex < cellValue.length) {
    segments.push(cellValue.substring(lastIndex));
  }
  return segments;
};
export function MetaTextCellRenderer(props) {
  const $ = _c(13);
  let t0;
  if ($[0] !== props.column) {
    t0 = getCellClassName(props.column);
    $[0] = props.column;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const className = t0;
  let t1;
  if ($[2] !== props.getTooltipProps || $[3] !== props.row) {
    t1 = getTooltipProps(props.row, {}, props.getTooltipProps);
    $[2] = props.getTooltipProps;
    $[3] = props.row;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const tooltipProps = t1;
  const cellValue = props.value?.primary ?? null;
  let t2;
  if ($[5] !== cellValue) {
    t2 = typeof cellValue === "string" ? parseMetaText(cellValue) : [cellValue];
    $[5] = cellValue;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const renderedValue = t2;
  let t3;
  if ($[7] !== className || $[8] !== renderedValue) {
    t3 = <div className={className}>{renderedValue}</div>;
    $[7] = className;
    $[8] = renderedValue;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3 || $[11] !== tooltipProps) {
    t4 = <Tooltip {...tooltipProps}>{t3}</Tooltip>;
    $[10] = t3;
    $[11] = tooltipProps;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}